import { gql, useQuery } from '@apollo/client';
import React from 'react';
import { Loading } from '../../../../components/Loading';
import { Graph } from '../../../../generated/graph';

const QUERY_APPROVED_ORDER = gql`
  query {
    loginlessOrderList(status: APPROVED, order: DESC) {
      id
      phoneNumber
      customerName
      status
      total
    }
  }
`;

function roundNumber(value: number) {
  return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function showTableItem(data: Graph.LoginlessOrder[]) {
  return (
    <table className="table table-padded">
      <thead>
        <tr>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Total Price</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {data.map((child, idx) => (
          <tr key={idx}>
            <td>{child.customerName}</td>
            <td>0{child.phoneNumber}</td>
            <td>${roundNumber(Number(child.total))}</td>
            <td>{child.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function LoginLessOrderApproved(){
  const { data, loading } = useQuery<Graph.Query>(QUERY_APPROVED_ORDER);
  
  if(data === undefined || loading) {
    return (
      <div>
        <Loading />
      </div>
    )
  }

  return data!.loginlessOrderList ? showTableItem(data.loginlessOrderList) : <Loading />
}